import useTypeTracking from '../../../analytics';

export const BUTTON_TYPE = 'USER_PROFILE_PAGE';
export const SETTINGS_BUTTON_TYPE = 'PROFILE_SETTINGS';

export const CATEGORIES = {
    open: 'MY_PROFILE_VIEW',
    hide: 'PROFILE_HIDE',
    unHide: 'PROFILE_UNHIDE',
    edit: 'PROFILE_SECTION_EDIT',
    cancel: 'MY_PROFILE_CANCEL',
    save: 'MY_PROFILE_SAVE',
};

const useProfileAnalytics = () => {
    const { trackClickEvent } = useTypeTracking();

    const sendEnterEditMode = () => {
        trackClickEvent({
            subCategory: CATEGORIES.edit,
        });
    };

    const sendLeaveEditMode = () => {
        trackClickEvent({
            subCategory: CATEGORIES.cancel,
        });
    };

    const sendProfileOpen = () => {
        trackClickEvent({
            subCategory: CATEGORIES.open,
        });
    };

    const sendMobileProfileOpen = () => {
        trackClickEvent({
            buttonType: BUTTON_TYPE,
            subCategory: CATEGORIES.open,
        });
    };

    const sendProfileSaved = () => {
        trackClickEvent({
            subCategory: CATEGORIES.save,
        });
    };

    const sendHideProfile = (isHidden: boolean) => {
        trackClickEvent({
            subCategory: isHidden ? CATEGORIES.hide : CATEGORIES.unHide,
        });
    };

    return {
        sendEnterEditMode,
        sendLeaveEditMode,
        sendProfileOpen,
        sendMobileProfileOpen,
        sendProfileSaved,
        sendHideProfile,
    };
};

export default useProfileAnalytics;
